import { Tab, TabProps, useTheme } from "@mui/material";
import { PRIMARY } from "src/theme/palette";

const StyledSoftTab = ({
  selected,
  title,
  ...others
}: {
  selected: boolean;
  title: string;
} & TabProps) => {
  const theme = useTheme();

  return (
    <Tab
      label={title}
      disableRipple
      sx={{
        textTransform: "none",
        borderRadius: 1,
        px: 2.5,
        py: 1,
        minHeight: 0,
        minWidth: 0,
        fontSize: 14,
        fontWeight: selected ? 700 : 500,
        backgroundColor: selected ? "primary.lighter" : "grey.100",
        border: selected ? "1px solid" : "1px solid transparent",
        borderColor: selected ? "primary.light" : "transparent",
        "&:hover": {
          backgroundColor: selected ? "primary.lighter" : "grey.200",
        },
        marginRight: "0px !important",
        color: `${selected ? PRIMARY.dark : theme.palette.text.secondary} !important`,
      }}
      {...others}
    />
  );
};

export default StyledSoftTab;
